module.exports = __webpack_public_path__ + "img/hospital.0245e85a.png";